import { Calculator, ExternalLink, Plus } from 'lucide-react';
import { environment } from '../../../../environments/environment';
import { useHostNavigate } from '../../../shared/ui';

/**
 * The two ways to start.
 *
 * This is what the old dashboard's whole page was: a "Budget" card and a
 * "Quote" card, each holding one sentence and a button. They are kept, because
 * they are genuinely the two things a distributor comes here to start — but as
 * one panel rather than the entire screen.
 */
export function StartQuotePanel() {
  const hostNavigate = useHostNavigate();

  return (
    <section className="bg-white border border-hilevel-border rounded-lg p-4">
      <h3 className="text-sm font-semibold text-hilevel-slate m-0">Start something</h3>
      <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2">
        <button
          type="button"
          onClick={() => hostNavigate('/quote/new')}
          className="flex items-start gap-3 p-3 text-left bg-hilevel-red text-white border-0 rounded-md cursor-pointer hover:bg-hilevel-red/90 transition-colors"
        >
          <Plus className="mt-0.5" />
          <span className="min-w-0">
            <span className="block text-sm font-medium">New quotation</span>
            <span className="block text-[11px] text-white/80">Price a mezzanine floor in full</span>
          </span>
        </button>

        <button
          type="button"
          onClick={() => window.open(environment.links.budgetCalculator, '_blank', 'noopener')}
          className="flex items-start gap-3 p-3 text-left bg-hilevel-offwhite hover:bg-hilevel-light border border-hilevel-border rounded-md cursor-pointer transition-colors group"
        >
          <Calculator className="mt-0.5 text-hilevel-gray group-hover:text-hilevel-red transition-colors" />
          <span className="min-w-0">
            <span className="block text-sm font-medium text-hilevel-slate">
              Budget figure
              <ExternalLink className="ml-1 text-[9px] text-hilevel-gray" />
            </span>
            <span className="block text-[11px] text-hilevel-gray">
              A rough order of cost in a minute
            </span>
          </span>
        </button>
      </div>
    </section>
  );
}
